import React, { useState } from "react";

/**
 * Input — Labelled text input matching the auth-page design.
 */
export default function Input({
  label,
  type = "text",
  placeholder,
  value,
  onChange,
  id,
  error,
  helperText,
  ...rest
}) {
  const [focused, setFocused] = useState(false);
  const inputId = id || label?.toLowerCase().replace(/\s+/g, "-");

  return (
    <div style={{ marginBottom: 16 }}>
      {label && (
        <label htmlFor={inputId} style={styles.label}>
          {label}
        </label>
      )}
      <input
        id={inputId}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={{
          ...styles.input,
          borderColor: error ? "#e53e3e" : focused ? "#2563eb" : "#e5e7eb",
          boxShadow: focused ? "0 0 0 3px rgba(37, 99, 235, 0.12)" : "none",
        }}
        {...rest}
      />
      {helperText && !error && <p style={styles.helper}>{helperText}</p>}
      {error && <p style={styles.error}>{error}</p>}
    </div>
  );
}

const styles = {
  label: {
    display: "block",
    fontSize: 14,
    fontWeight: 600,
    color: "#1a1a1a",
    marginBottom: 6,
    fontFamily: "'Inter', sans-serif",
  },
  input: {
    width: "100%",
    padding: "10px 14px",
    fontSize: 14,
    fontFamily: "'Inter', sans-serif",
    color: "#1a1a1a",
    backgroundColor: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    outline: "none",
    boxSizing: "border-box",
    transition: "border-color 0.15s, box-shadow 0.15s",
  },
  error: {
    marginTop: 4,
    fontSize: 12,
    color: "#e53e3e",
  },
  helper: {
    margin: "5px 0 0",
    fontSize: 12,
    lineHeight: 1.4,
    color: "#6b7280",
  },
};
